/**
 * Generic helper type that makes a field present (non-null) when the load set includes the key
 * @param L - The load set type (object with boolean flags for loaded relations)
 * @param K - The key to check in the load set
 * @param T - The type to make present/optional
 */
export type PresentIf<L extends Record<string, boolean>, K extends keyof L, T> =
  L extends Record<K, true> ? T : T | undefined;

/**
 * Generic helper type that makes a field optional when the load set includes the key
 * @param L - The load set type (object with boolean flags for loaded relations)
 * @param K - The key to check in the load set
 * @param T - The type to make optional
 */
export type OptionalIf<L extends Record<string, boolean>, K extends keyof L, T> =
  L extends Record<K, true> ? T | null | undefined : T;

/**
 * Generic helper type that makes a field required when the load set includes the key
 * @param L - The load set type (object with boolean flags for loaded relations)
 * @param K - The key to check in the load set
 * @param T - The type to make required/optional
 */
export type RequiredIfLoaded<L extends Record<string, boolean>, K extends keyof L, T> =
  L extends Record<K, true> ? T : T | null | undefined;
